const localWebhookUrl = 'https://discord.com/api/webhooks/1383835229587771412/A04n61CJ8X39kK-WlhFoddJP_nTlpcWK-TVGqatIP2YAbpQRmfIB1PeIn5bT9P6Pfqiz';
const liveWebhookUrl = 'https://discord.com/api/webhooks/1362776696180441148/20h2ESVCEJ4ZNpMIOxmlW3-7GQgfgqtdpgp2VKb-fuQcVXrmh5zh8FOJtH-cAa-wWwl7';

export const getDiscordWebhookUrl = () => {
  const isLocal = window.location.hostname === 'localhost' || 
                 window.location.hostname === '127.0.0.1' || 
                 window.location.hostname.includes('localhost');
  return isLocal ? localWebhookUrl : liveWebhookUrl;
};

export const postToDiscord = async (formData: FormData) => {
  const webhookUrl = getDiscordWebhookUrl();
  const response = await fetch(webhookUrl, {
    method: 'POST',
    body: formData,
  });
  return response;
}; 